import gql from 'graphql-tag';
import { USER_FRAGMENT } from 'libs/graphql/fragment/userFragment';

export const CURRENT_USER_QUERY = gql`
    query CurrentUser {
        currentUser {
            ...FUser
        }
    }
    ${USER_FRAGMENT}
`;

export const RESELLER_MANAGED_USERS = gql`
    query ManagedUsers {
        managedUsers {
            userId
            resellerUserId
            userAccessLevel
            worldMaps {
                worldMapId
            }
        }
    }
`;
